import request from '@/utils/request'
import store from '../store'
export function GetDoctorsWorkByDepartId(datas) {
  return request({
    url: 'Statistics/GetDoctorsWorkByDepartId',
    method: 'get',
    params: { departId: store.getters.departId, startDate: datas.startDate, endDate: datas.endDate, visitors: datas.visitors || false }
  })
}
export function GetRegistrationInfoByDepartId(datas) {
  return request({
    url: 'Statistics/GetRegistrationInfoByDepartId',
    method: 'get',
    params: { departId: store.getters.departId, startDate: datas.startDate, endDate: datas.endDate }
  })
}
export function GetModalityCountByDepartId(datas) {
  return request({
    url: 'Statistics/GetModalityCountByDepartId',
    method: 'get',
    params: { departId: store.getters.departId, startDate: datas.startDate, endDate: datas.endDate }
  })
}
export function GetDoctorsWorkForPI(datas) {
  return request({
    url: 'Statistics/GetDoctorsWorkForPI',
    method: 'get',
    params: { departId: store.getters.departId, startDate: datas.startDate, endDate: datas.endDate }
  })
}
export function GetModalityCountForPI(datas) {
  return request({
    url: 'Statistics/GetModalityCountForPI',
    method: 'get',
    params: { departId: store.getters.departId, startDate: datas.startDate, endDate: datas.endDate }
  })
}
export function GetSelfDepartPositiveRate(datas) {
  return request({
    url: 'Statistics/GetSelfDepartPositiveRate',
    method: 'get',
    params: { departId: store.getters.departId, startDate: datas.startDate, endDate: datas.endDate }
  })
}
